export function isBeamImpactEmail(email: string) {
  return email.includes('@beamimpact.com')
}
